import type { OrderItem } from "../../models/order-item";
import { ProductsCard } from "../cart/products-card";

type OrderCartProps = {
  items?: OrderItem[];
  totalPrice?: number;
};

export const OrderCart = ({ items, totalPrice }: OrderCartProps) => {
  if (!items?.length) return null;

  return (
    <div className="flex flex-col gap-4">
      <ProductsCard products={items} totalPrice={totalPrice ?? 0} />
    </div>
  );
};
